module.exports = __webpack_public_path__ + "img/33_54.6b11006e.png";